import { useCallback, useEffect } from "react";

interface Hotkeys {
  [index: string]: () => void;
}

type Keymap = {
  key?: string;
  modifier?: string;
  handler?: (event: KeyboardEvent) => void;
};

export default (hotkeys: Hotkeys) => {
  const map: Keymap[] = Object.keys(hotkeys)
    .map((hk) => {
      const [modifier, key] = hk.split("+").map((k) => k.trim());
      return { key, modifier, handler: hotkeys[hk] };
    })
    .filter((km) => km);

  const listener = useCallback(
    (event: KeyboardEvent) => {
      const { key, altKey, ctrlKey, shiftKey, repeat } = event;
      if (repeat) return;

      const { modifier, handler } = map.find((k) => k.key === key) || {};

      if (!modifier || !handler) return;

      switch (true) {
        case modifier === "ctrl" && ctrlKey:
        case modifier === "alt" && altKey:
        case modifier === "shift" && shiftKey:
          handler?.(event);
      }
    },
    [map],
  );

  useEffect(() => {
    document.addEventListener("keydown", listener, { capture: true });

    return () => {
      document.removeEventListener("keydown", listener, {
        capture: true,
      });
    };
  }, [listener]);
};
